import(/* webpackMode: "eager", webpackExports: ["Button"] */ "__barrel_optimize__?names=Button!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/app/components/common/Button/Button.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Card/Review.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Header/Layout/Default.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/Image/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/SectionDownloadApp/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/Section/ShopVerticalSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
